
import setting from '../../../server/settings'
import api from '~api'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: "loan",
directives: {
TransferDom
},
components: {
XHeader,Group,Selector,XInput,Toast,Previewer
},
data() {
return {
baseurl: setting.api_root+ '/api/greenchannel/imgLook?params=',
title: "生源地贷款",
stuinfo:{

},
state:0,
loaninfo:{




},
loan:{




},

imageUrl: [],
showtoast:false,
toasttext:'',
statusArray: [{
key: '0',
value: '未审核'
}, {
key: '1',
value: '审核通过'
}, {
key: '2',
value: '审核不通过'
}],
}
},
mounted(){

api.post("/api/NewReports/findInformation", {"stuCode": this.$route.params.stunum}).then( res=>{
if(res.status==200){
this.stuinfo = res.data.results[0];
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
}
})
const param = {
"stuCode": this.$route.params.stunum,
"year": this.$route.params.year,
}
api.post("/api/greenChannelAudit/selectLoanMsg",param).then( res=>{
if(res.status==200){
if(res.data.msg && res.data.msg.length > 0 ){
if(res.data.msg[0].applyCode=="" || res.data.msg[0].applyCode==null){
this.state = 0;
}else{
this.loaninfo = res.data.msg[0];
this.state = 2;
}
}
}
})

},
methods:{
backPage(){
this.$router.push({name:'checkloan'})
},
changeCheck(){
if(this.loaninfo.status == '' || this.loaninfo.status ==null || this.loaninfo.status == '0'){
this.toasttext = "请选择审核状态";
this.showtoast=true;
return false;
}
return true;
},
goedit(){
if(this.changeCheck()){
this.$vux.loading.show({
text: '加载中，请稍候！'
})
var param = {
'status': this.loaninfo.status,
'userId': window.localStorage.getItem("userId"),
'stuCode': this.$route.params.stunum,
'reason': this.loaninfo.reason,
'auditType': this.loaninfo.auditType,
'year': this.loaninfo.year,
'verifyId': this.loaninfo.verifyId,
};
api.post("/api/greenChannelAudit/updateStatus", param).then( res=>{
if(res.status==200){
if(res.data.results=='1'){








this.$router.push({name:'checkloan'})
}else{
this.$msgbox('温馨提示：',"申请审核失败！");
}
}
this.$vux.loading.hide()
})

}
},

}
}



// WEBPACK FOOTER //
// ./src/components/audit/loanDetile.vue